export default __webpack_public_path__ + "3d5923f94fc319b5652a7feb9dfa2b28.ttf";